import { useState } from 'react';

import { MktMenu } from '@playbooks/components/mkt/mkt-menu';
import { MktSlide } from '@playbooks/components/mkt/mkt-slide';
import { useClient, useSession } from '@playbooks/contexts';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

const MktNavbarList = () => {
	const [open, setOpen] = useState(false);
	const session = useSession();
	const { platformHref } = useClient();

	// Render
	return (
		<div className='ml-auto flex-end grow gap-1'>
			<MktMenu />
			<Link
				variant='ghost'
				size='sm'
				href={platformHref('/contact')}
				className='hidden rounded-panel font-normal lg:inline-flex'>
				Contact
			</Link>
			<div className='mx-3 hidden h-4 border-r lg:block' />
			{session?.user?.id ? (
				<Link variant='outline' size='sm' href={platformHref('/home')} className='rounded-panel font-normal'>
					<Icon data-icon='inline-start' type='far' icon='home' aria-hidden />
					Dashboard
				</Link>
			) : (
				<Link size='sm' href={platformHref('/auth')} className='hidden rounded-panel font-normal lg:inline-flex'>
					Sign in
				</Link>
			)}
			<div className='lg:hidden'>
				<MktSlide target='' open={open} setOpen={setOpen} />
			</div>
		</div>
	);
};

export { MktNavbarList };
